var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/GStationApi/DocumentManagement.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../domain';
export var DocumentManagement;

(function (_DocumentManagement) {
  var domain = ApiDomain.domain('DocumentManagement', {
    name: "domain",
    sid: "-r7wkn8"
  });
  var ModelDerivative;

  (function (_ModelDerivative) {
    var derivative = _ModelDerivative.derivative = t.type({
      name: t.string,
      type: t.string,
      role: t.union([t.literal('3d'), t.literal('2d'), t.literal('resource')]),
      resource: t.string,
      thumbnail: t.union([t.string, t["null"]]),
      mimeType: t.string,
      uuid: t.string,
      resolution: t.union([t.array(t.number), t.undefined])
    });
    var derivativeFile = _ModelDerivative.derivativeFile = t.type({
      urn: t.string,
      version: t.number,
      derivatives: t.array(derivative)
    });
    var io = _ModelDerivative.io = t.type({
      files: t.array(derivativeFile)
    }, 'ModelDerivative');
  })(ModelDerivative || (ModelDerivative = _DocumentManagement.ModelDerivative || (_DocumentManagement.ModelDerivative = {})));

  var fetchModelDerivative = _DocumentManagement.fetchModelDerivative = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: ModelDerivative.io,
    getKey: ['projectId']
  });
})(DocumentManagement || (DocumentManagement = {}));